import React, { Component } from "react";
import queryString from "query-string";
import { newSearchURL, findValueInArray, getClosest } from "./../../Utils";

export class StepOptionsCheckbox extends Component {
  state = {
    options: [],
    setInitialCheckboxValue: false
  };

  handleCheckbox = ev => {
    if (getClosest(ev.target, ".wizard-app-checkbox")) {
      let parent = getClosest(ev.target, ".wizard-app-checkbox");
      if (parent) {
        if (parent.querySelector(".card").classList.contains("active")) {
          parent.querySelector(".card").classList.remove("active");
          parent.querySelector("input").checked = false;
        } else {
          parent.querySelector(".card").classList.add("active");
          parent.querySelector("input").checked = true;
        }
      }
    }
  };

  handleStepParam = (ev, stepParamURL, props) => {
    const { history, location } = props;
    const { pathname, search } = location;

    const paramsURL = queryString.parse(search);
    const actualStepValue = paramsURL[`step${stepParamURL}`];
    let options = this.state.options;
    

    if (actualStepValue !== "empty" && !this.state.setInitialCheckboxValue) {
      options = actualStepValue.split(",");
      this.setState({
        setInitialCheckboxValue: true
      });
    }

    let index;
    if (ev.target.checked) {
      options.push(ev.target.value);
    } else {
      index = options.indexOf(ev.target.value);
      options.splice(index, 1);
    }

    this.setState({ options: options });

    let newURL;

    if (options.length > 0) {
      newURL = newSearchURL(
        `step${stepParamURL}=${actualStepValue}`,
        `step${stepParamURL}=${options.join(",")}`,
        location
      );
    } else {
      newURL = newSearchURL(
        `step${stepParamURL}=${actualStepValue}`,
        `step${stepParamURL}=empty`,
        location
      );
    }

    const newStepValue = `${pathname}${newURL}`;

    history.push(newStepValue);
  };

  render() {
    const { step, props } = this.props;

    const { location } = props;
    const { search } = location;

    const paramsURL = queryString.parse(search);
    const actualStepValue = paramsURL[`step${props.stepParamURL}`];

    return (
      <div data-test="StepOptionsCheckboxComponent">
        <div
          className="card-holder"
          style={{ maxWidth: "600px" , margin: "0 auto" }}
        >
          <h1 className="d-none d-md-block header-step">Por solo 1€ enriquece tu lipstick!</h1>
          <h6 className="text-uppercase font-weight-700 font-size-14px mb-4">Cuida tus labios, añade superpowers</h6>
          <div className="card-wizard">
            {step &&
              step.addons.map((addon, index) => {                
                const valueFinded =
                  actualStepValue &&
                  findValueInArray(actualStepValue.split(","), index);

                return (
                  <div
                    className="wizard-app-checkbox"
                    key={addon.ID}
                    onClick={this.handleCheckbox}
                    data-checked={
                      actualStepValue === "empty"
                        ? false
                        : parseInt(valueFinded) === index && true
                    }
                  >
                    <div
                      className={`card card-t1 card-checkbox mb-3 ${
                        actualStepValue === "empty"
                          ? ""
                          : parseInt(valueFinded) === index && "active"
                      }`}
                    >
                      <div className="helper">
                          {addon.image && (
                            <img
                              src={addon.image}
                              className="card-img"
                              alt="Imagen"
                            />
                          )}
                          <div className="card-body">
                            <h5 className="card-title mb-2">
                              {addon.post_title}{" "}
                              <i
                                className="icon-info-circle icon-tooltip float-right"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Tooltip on top"
                              ></i>
                            </h5>
                            {addon.desc && (
                              <p className="card-text mb-2">{addon.desc}</p>
                            )}
                            {addon.info && <div className="note">{addon.info}</div>}
                            {addon.badge && (
                              <span className="badge">
                                <img src={addon.badge} alt="Badge" />
                              </span>
                            )}
                            {addon.price && (
                              <div className="card-price-badge">
                                <span>+{addon.price}&euro;</span>
                              </div>
                            )}
                            <input
                              type="checkbox"
                              value={index}
                              onChange={ev =>
                                this.handleStepParam(ev, props.stepParamURL, props)
                              }
                              checked={
                                actualStepValue === "empty"
                                  ? false
                                  : parseInt(valueFinded) === index && true
                              }
                            />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}

export default StepOptionsCheckbox;
